var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9881 2.4571C14.9881 1.09984 13.9121 0 12.5842 0L2.39973 0.0117005C1.07564 0.0117005 -0.000424289 1.11154 -0.000424289 2.4688V18.6271C-0.0195034 19.3565 0.457474 19.9337 1.1634 20H5.33791V17.0359C5.33791 16.4431 5.80726 15.9633 6.38726 15.9633H8.6157C9.19571 15.9633 9.66505 16.4431 9.66505 17.0359V20H13.748C14.4883 19.9844 15.0187 19.3916 15.0034 18.6232L14.9919 2.4532L14.9881 2.4571ZM4.07487 12.032H1.59841V9.50078H4.07487V12.032ZM4.07487 8.51014H1.59841V5.97894H4.07487V8.51014ZM4.07487 4.9922H1.59841V2.461H4.07487V4.9922ZM8.73781 12.032H6.26134V9.50078H8.73781V12.032ZM8.73781 8.51014H6.26134V5.97894H8.73781V8.51014ZM8.73781 4.9922H6.26134V2.461H8.73781V4.9922ZM13.4007 12.032H10.9243V9.50078H13.4007V12.032ZM13.4007 8.51014H10.9243V5.97894H13.4007V8.51014ZM13.4007 4.9922H10.9243V2.461H13.4007V4.9922Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiFamily);
export default __webpack_public_path__ + "static/media/multi-family.fc7ed079525dc3158587874c5f4e89c2.svg";
export { ForwardRef as ReactComponent };